"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _reactI18next = require("react-i18next");
var _hacks = require("../helpers/hacks");
var _misc = require("../helpers/misc");
exports.default = {
  eventtiaBase: 'https://connect.eventtia.com',
  setEventtiaBase: function setEventtiaBase(eventtiaBase) {
    this.eventtiaBase = eventtiaBase || this.eventtiaBase;
  },
  getApiRoot: function getApiRoot() {
    var locale = window.location.pathname.split('/')[1];
    if (!['en', 'es', 'fr', 'de'].includes(locale)) {
      locale = 'en';
    }
    return this.eventtiaBase + "/" + locale + "/api/v3/";
  },
  buildQuery: function buildQuery() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var keys = Object.keys(params).filter(function (key) {
      return typeof params[key] !== 'undefined';
    }).filter(function (key) {
      return !!String(params[key]).trim();
    });
    if (!keys.length) return '';
    var result = {};
    keys.forEach(function (key) {
      result[key] = params[key];
    });
    var queryParams = new URLSearchParams(result);
    return queryParams.size ? "?" + queryParams.toString() : '';
  },
  getFormLanguage: function getFormLanguage() {
    return (0, _misc.getQueryParam)('form-language') || sessionStorage.getItem('website_lang') || window.location.pathname.split('/')[1];
  },
  getEditRegistrationUrl: function getEditRegistrationUrl(eventUri) {
    var formLanguage = this.getFormLanguage();
    var _getAllQueryParams = (0, _misc.getAllQueryParams)(),
      uuid = _getAllQueryParams.uuid,
      token = _getAllQueryParams.token;
    var utmParams = (0, _misc.getUtmParams)();
    var queryString = this.buildQuery(_extends({
      token: token
    }, utmParams));
    return this.eventtiaBase + "/" + formLanguage + "/public/events/" + eventUri + "/registration/attendees/" + uuid + "/update" + queryString;
  },
  getCancelRegistrationUrl: function getCancelRegistrationUrl(eventUri) {
    var formLanguage = this.getFormLanguage();
    var _getAllQueryParams2 = (0, _misc.getAllQueryParams)(),
      uuid = _getAllQueryParams2.uuid,
      token = _getAllQueryParams2.token;
    var utmParams = (0, _misc.getUtmParams)();
    var queryString = this.buildQuery(_extends({
      token: token
    }, utmParams));
    return this.eventtiaBase + "/" + formLanguage + "/public/events/" + eventUri + "/registration/attendees/" + uuid + "/cancel-attendance" + queryString;
  },
  getPublicRegisterUrl: function getPublicRegisterUrl(eventUri, attendee_type, event_id) {
    var formLanguage = this.getFormLanguage();
    var utmParams = (0, _misc.getUtmParams)();
    var queryParams = _extends({}, utmParams);
    if (attendee_type) queryParams.attendee_type = attendee_type;
    if (eventUri === 'soirees-formation-a-derma') queryParams = _extends({}, queryParams, (0, _hacks.buildAdermaHackObject)(attendee_type));
    var queryString = this.buildQuery(queryParams);
    if (['virtualityparis', 'verizon2019', 'fbf2020', '7934', 'franceattractive', '4th-international-workshops-of-eczema-foundation', '6emejourneeshospitalieres', 'pure2020', '2019'].includes(eventUri)) return this.eventtiaBase + "/" + formLanguage + "/public/events/" + eventUri + "/registration/attendees" + queryString;
    if (['perrier-jouet-popup-event-h1', 'wine-seminar-fy24h1'].includes(eventUri)) return this.eventtiaBase + "/ja/public/events/" + eventUri + "/registration/attendees" + (queryString || window.location.search);
    if (eventUri === 'europeanbuyersforum26novembre2019') return this.eventtiaBase + "/" + window.location.pathname.split('/')[1] + "/dmz/" + eventUri + "/website/register" + queryString;
    if (eventUri === 'soirees-formation-a-derma') return this.eventtiaBase + "/" + window.location.pathname.split('/')[1] + "/dmz/" + eventUri + "/website/register" + queryString;

    // New eventtia registration form
    if (event_id > 14455) return this.eventtiaBase + "/" + formLanguage + "/public/events/" + eventUri + "/registration/attendees" + (queryString || window.location.search);
    return this.eventtiaBase + "/" + formLanguage + "/dmz/" + eventUri + "/website/register" + queryString;
  },
  getPublicLoginUrl: function getPublicLoginUrl(eventUri, event_language) {
    return this.eventtiaBase + "/" + event_language + "/dmz/" + eventUri + "/website/login";
  },
  getSubmitContactFormUrl: function getSubmitContactFormUrl(eventUri) {
    return this.getApiRoot() + "events/" + eventUri + "/contact_message";
  },
  getSendEditRegistrationMagicTokenUrl: function getSendEditRegistrationMagicTokenUrl(eventUri) {
    return this.getApiRoot() + "events/" + eventUri + "/attendees/registration_magic_link_email";
  }
};